// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";
import rootReducer from "./rootReducer";
import { firebaseConfig } from "../firebase/firebaseDev";

const persistConfig = {
  key: "root",
  storage,
  // Optionally, specify which reducers to persist
  whitelist: [""],
};

const projectId = firebaseConfig.projectId;
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          endpoint: `https://us-central1-${projectId}.cloudfunctions.net/`, //backend endpoint
        },
      },
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  devTools: process.env.ENV_NAME !== "Prod",
});

export const persistor = persistStore(store);

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);
